'use client'

import { useEffect, useRef } from 'react'

import type { PriceInfo } from './use-cart-prices'

/**
 * Forwards changing line totals to `onPriceReport` while ignoring unstable callback references.
 *
 * @param onPriceReport - Parent callback; may be recreated each render.
 * @param payload - Latest `total`, `savings`, and `namePrice` (skip emit when `namePrice` is `null`).
 */
export function useReportProductLinePrice(
	onPriceReport: ((info: PriceInfo) => void) | undefined,
	payload: { total: number; savings: number; namePrice: number | null; name: string }
) {
	const reporterRef = useRef(onPriceReport)
	useEffect(() => {
		reporterRef.current = onPriceReport
	})
	useEffect(() => {
		if (payload.namePrice !== null) {
			reporterRef.current?.({ total: payload.total, savings: payload.savings, name: payload.name })
		}
	}, [payload.total, payload.savings, payload.namePrice, payload.name])
}
